import React from "react";
import { inject } from "mobx-react";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import PartnersContainer from "Containers/PartnersContainer";
import { Redirect404 } from "ComponentsUI/Redirects";

@inject("ApplicationModel")
class Partner extends React.Component {
	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = "/about/partners";

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	render() {
		const {
			ApplicationModel: { currentRegion },
			match: { params },
		} = this.props;

		if (params?.regionUrl && params?.regionUrl !== currentRegion?.url) {
			return <Redirect404 message404={`Несовпадение regionUrl: ${params?.regionUrl}`} />;
		}

		return (
			<>
				{this.canonical()}
				<PartnersContainer />
			</>
		);
	}
}

export default withRouter(Partner);
